import { AVATAR_DEFAULT } from '~constants'
import Pet from '~models/pet'
import Avatar from '.'
import { AvatarPetProps } from './types'

const getDefaultPlaceholderPhoto = (pet?: Pet.ILevel1 | Pet.UpdateDraft) => {
  if (!pet) {
    return AVATAR_DEFAULT.PET.OTHERS
  }

  if (Pet.isUpdateDraft(pet)) {
    switch (pet.species?.toLowerCase()) {
      case 'cat':
        return AVATAR_DEFAULT.PET.CAT
      case 'dog':
        return AVATAR_DEFAULT.PET.DOG
      case 'bird':
        return AVATAR_DEFAULT.PET.BIRD
      default:
        return AVATAR_DEFAULT.PET.OTHERS
    }
  }

  if (pet?.kind && pet.kind.main) {
    switch (pet.kind.main.toLowerCase()) {
      case 'cat':
        return AVATAR_DEFAULT.PET.CAT
      case 'dog':
        return AVATAR_DEFAULT.PET.DOG
      case 'bird':
        return AVATAR_DEFAULT.PET.BIRD
      default:
        return AVATAR_DEFAULT.PET.OTHERS
    }
  } else {
    return AVATAR_DEFAULT.PET.OTHERS
  }
}

const AvatarPet = ({ pet, alt, size, className }: AvatarPetProps) => {
  const defaultPlaceholderPhotoUri = getDefaultPlaceholderPhoto(pet)
  const photoUri = pet?.photo_url || defaultPlaceholderPhotoUri

  return <Avatar uri={photoUri} alt={alt} size={size} className={className} />
}

export default AvatarPet
